import React, {createContext, useState} from "react";

export const MemoryCountDownContext = createContext();

const MemoryCountDownContextProvider = (props) => {
    const [showCounter, setShowCounter] = useState(true);
    const [countDownFinished, setCountDownFinished] = useState(false);

    const handleShowCounter = (show) => {
        setShowCounter(show);
    };

    const updateCountDown = (status) => {
        setCountDownFinished(status);
    };

    return(
        <MemoryCountDownContext.Provider value={{showCounter, handleShowCounter, countDownFinished, updateCountDown}}>{props.children}</MemoryCountDownContext.Provider>
    );
};

export default MemoryCountDownContextProvider;